// removed by extract-text-webpack-plugin
module.exports = {"container":"AdminFooter__container__1gBXA","leftSection":"AdminFooter__leftSection__1lfm7","rightSection":"AdminFooter__rightSection__rJyGl"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/AdminFooter/AdminFooter.css
// module id = 565
// module chunks = 0